import styled, { css } from 'styled-components';
import { designTokens } from '../../ui/foundation/DesignTokens';

// Navigation Container - Clean, no background
export const LinksContainer = styled.nav`
  display: flex;
  align-items: center;
  /* "safe": when the links do not fit, start from the left edge instead of
     splitting the overflow, so the first link (Inicio) is never clipped out of
     reach of the horizontal scroll. Plain "center" stays as the fallback. */
  justify-content: center;
  justify-content: safe center;
  gap: 4px;
  height: 100%;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 4px;

  /* Hide scrollbar but keep functionality */
  &::-webkit-scrollbar {
    height: 0;
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;

  @media (max-width: 1100px) {
    justify-content: flex-start;
    gap: 6px;
  }
`;

// Navigation Item - Vertical layout with icon above label
export const LinkContainer = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 12px;
  height: 56px;
  border-radius: ${designTokens.radius.lg};
  text-decoration: none;
  color: ${designTokens.colors.gray[600]};
  font-family: ${designTokens.fonts.heading};
  font-size: ${designTokens.fontSizes.xs};
  font-weight: 600;
  transition: all 0.15s ease;
  white-space: nowrap;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  flex-shrink: 0;
  min-width: 64px;

  &:hover {
    background: ${designTokens.colors.gray[100]};
    color: ${designTokens.colors.gray[900]};
  }

  ${(props) =>
    props.isActive &&
    css`
      background: ${designTokens.colors.nav.activeBg};
      color: ${designTokens.colors.nav.activeText};
    `}

  @media (max-width: 1200px) {
    padding: 6px 10px;
    min-width: 56px;
    font-size: 0.7rem;
    height: 56px;
  }

  @media (max-width: 900px) {
    padding: 4px 8px;
    min-width: 48px;
    font-size: 0.65rem;
    height: 46px;
  }
`;

// Link Icon - Above label
export const LinkIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: inherit;
  transition: all 0.15s ease;

  svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
  }

  ${(props) =>
    props.isActive &&
    css`
      color: ${designTokens.colors.nav.activeText};
    `}

  @media (max-width: 900px) {
    width: 24px;
    height: 24px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

// Link Name - Below icon
export const LinkName = styled.span`
  display: block;
  font-family: ${designTokens.fonts.heading};
  font-weight: 600;
  color: inherit;
  letter-spacing: -0.01em;
  font-size: inherit;
  text-transform: none;
  line-height: 1.2;

  @media (max-width: 768px) {
    display: none;
  }
`;

// Emoji Icon (for bot menu)
export const EmojiIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  font-size: ${designTokens.fontSizes.base};
  line-height: 1;
  background: ${designTokens.colors.accent[400]};
  border-radius: 50%;
  box-shadow: 0 0 0 3px ${designTokens.colors.warning[100]};
`;
